export default __webpack_public_path__ + "static/media/Group728.0f8d6ed8.svg";